import { render } from "./SpeedDialBtn.vue?vue&type=template&id=0d9ed314"
import script from "./SpeedDialBtn.vue?vue&type=script&lang=js"
export * from "./SpeedDialBtn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__